import { EBentoOrderForm } from '@/enums/order';

const getOrderFromName = (status: EBentoOrderForm): string => {
  switch (status) {
    case EBentoOrderForm.WEB:
      return 'BENTO WEB';
    default:
      return 'BENTO';
  }
};

export { getOrderFromName };
